import { createAction, handleActions } from "redux-actions";

const CHANGE_AGREE = "agree/CHANGE_AGREE";
const CHANGE_FORMS = "agree/CHANGE_FORMS";

export const changeAgr = createAction(CHANGE_AGREE);
export const changeForms = createAction(CHANGE_FORMS);

const initialState = {
  isAgree: false,
  showForms: false
};

export default handleActions(
  {
    [CHANGE_AGREE]: (state, { payload }) => ({ ...state, isAgree: payload }),
    [CHANGE_FORMS]: (state, { payload }) => ({ ...state, showForms: payload })
  },
  initialState
);
